import {
  Home,
  AboutUs,
  OurHistory,
  LeadershipTeam,
  NewsThrought,
  OurOffices,
  AnnualReport,
  Community,
  Golf,
  WhoWeServe,
  ConstructionInsurance,
  DealershipsInsurance,
  ManufactureInsurance,
  WhatWeOfferMain,
  DistributorsRetailers,
  TruckingInsurance,
  ServiceIndustries,
  WhyChooseSentry,
  InsuranceProduct,
  WorkerCompensation,
  GeneralLiability,
  CommercialProperties,
  BussinessOwnerInsurance,
  BussinessAutoInsurance,
  Plans401kAndInsurance,
  Plan401k,
  Claims,
  Contactus,
  CustomerNotifications,
  LegalDisclaimer,
  TermsConditions,
  WebAccessibility,
  Customer,
  Agent,
  Privacy,
  Sitemap,
  BussinessLifeInsurance,
  AgricultureEquipment,
  BoatDealers,
  IndustrialEquipment,
  AutoDealerships,
  HarleyDavidsonDealerships,
  RvDealerships,
  ElectronicManufacturers,
  FoodProcessingInsurance,
  PlasticRubberGoods,
  FarmEquipmentManufacturing,
  MetalWorkingInsurance,
  PrintersInsurance,
  Distributors,
  RetailerInsurance,
  AutomotiveRepair,
  Communications,
  FinancialServices,
  HospitalityBusinesses,
  GolfInsurance,
  EducationalInsurance,
  HealthcareBusinesses,
  RealEstate,
  IndividualLifeInsurance,
  CommercialAutoInsurance,
  MotorCarrierInsurance,
  DealershipAutoCoverage,
  BusinessLiabilityInsurance,
  PropertyCoverage,
  BuildingInsurance,
  BusinessIncomeInsurance,
  BusinessPersonalInsurance,
  CrimeInsurance,
  EquipmentBreakdown,
  InlandMarineInsurance,
  CommercialUmbrellaInsurance,
  EmploymentPracticesInsurance,
  ErrorsOmissionsInsurance,
  GuaranteedCostInsurance,
  RetrospectiveInsurance,
  SmallDeductiblePlans,
  LargeDeductiblePlans,
  SelfInsuredPlans,
} from "../pages";


const RouteArr = [
  {
    name: "Home",
    path: "",
    key: "home",
    route: "/home",
    element: <Home />,
  },

  // About
  {
    name: "About",
    path: "/aboutus",
    key: "about",
    route: "/aboutus",
    element: <AboutUs />,
  },
  {
    name: "ourhistory",
    path: "/aboutus/ourhistory",
    key: "ourhistory",
    route: "/aboutus/ourhistory",
    element: <OurHistory />,
  },
  {
    name: "leadershipteam",
    path: "/aboutus/leadershipteam",
    key: "leadershipteam",
    route: "/aboutus/leadershipteam",
    element: <LeadershipTeam />,
  },
  {
    name: "newsthrought",
    path: "/aboutus/newsthrought",
    key: "newsthrought",
    route: "/aboutus/newsthrought",
    element: <NewsThrought />,
  },
  {
    name: "ouroffices",
    path: "/aboutus/ouroffices",
    key: "ouroffices",
    route: "/aboutus/ouroffices",
    element: <OurOffices />,
  },
  {
    name: "annualreport",
    path: "/aboutus/annualreport",
    key: "annualreport",
    route: "/aboutus/annualreport",
    element: <AnnualReport />,
  },
  {
    name: "community",
    path: "/aboutus/community",
    key: "community",
    route: "/aboutus/community",
    element: <Community />,
  },
  {
    name: "sentryandgolf",
    path: "/golf",
    key: "sentryandgolf",
    route: "/aboutus/sentryandgolf",
    element: <Golf />,
  },

  // Who we serve
  {
    name: "whoservemain",
    path: "/whoweserve",
    key: "whoservemain",
    route: "/whoweserve",
    element: <WhoWeServe />,
  },
  {
    name: "constructioninsurance",
    path: "/whoweserve/constructioninsurance",
    key: "constructioninsurance",
    route: "/whoweserve/constructioninsurance",
    element: <ConstructionInsurance />,
  },
  {
    name: "dealershipsinsurance",
    path: "/whoweserve/dealershipsinsurance",
    key: "dealershipsinsurance",
    route: "/whoweserve/dealershipsinsurance",
    element: <DealershipsInsurance />,
  },
  //delearship insurance subpages
  {
    name: "agriculture-equipment-dealerships",
    path: "/whoweserve/dealershipsinsurance/agriculture-equipment-dealerships",
    key: "agriculture-equipment-dealerships",
    route: "/whoweserve/dealershipsinsurance/agriculture-equipment-dealerships",
    element: <AgricultureEquipment />,
  },
  {
    name: "agriculture-equipment-dealerships",
    path: "/whoweserve/dealershipsinsurance/boat-dealers",
    key: "agriculture-equipment-dealerships",
    route: "/whoweserve/dealershipsinsurance/boat-dealers",
    element: <BoatDealers />,
  },
  {
    name: "industrial-equipment-dealers",
    path: "/whoweserve/dealershipsinsurance/industrial-equipment-dealers",
    key: "industrial-equipment-dealers",
    route: "/whoweserve/dealershipsinsurance/industrial-equipment-dealers",
    element: <IndustrialEquipment />,
  },
  {
    name: "auto-dealerships",
    path: "/whoweserve/dealershipsinsurance/auto-dealerships",
    key: "auto-dealerships",
    route: "/whoweserve/dealershipsinsurance/auto-dealerships",
    element: <AutoDealerships />,
  },
  {
    name: "harley-davidson-dealerships",
    path: "/whoweserve/dealershipsinsurance/harley-davidson-dealerships",
    key: "harley-davidson-dealerships",
    route: "/whoweserve/dealershipsinsurance/harley-davidson-dealerships",
    element: <HarleyDavidsonDealerships />,
  },
  {
    name: "rv-dealerships",
    path: "/whoweserve/dealershipsinsurance/rv-dealerships",
    key: "rv-dealerships",
    route: "/whoweserve/dealershipsinsurance/rv-dealerships",
    element: <RvDealerships />,
  },
  {
    name: "manufactureinsurance",
    path: "/whoweserve/manufactureinsurance",
    key: "manufactureinsurance",
    route: "/whoweserve/manufactureinsurance",
    element: <ManufactureInsurance />,
  },
  //manufacture insurance sub pages
  {
    name: "electronic-manufacturers",
    path: "/whoweserve/manufactureinsurance/electronic-manufacturers",
    key: "electronic-manufacturers",
    route: "/whoweserve/manufactureinsurance/electronic-manufacturers",
    element: <ElectronicManufacturers />,
  },
  {
    name: "food-processing-insurance",
    path: "/whoweserve/manufactureinsurance/food-processing-insurance",
    key: "food-processing-insurance",
    route: "/whoweserve/manufactureinsurance/food-processing-insurance",
    element: <FoodProcessingInsurance />,
  },
  {
    name: "plastic-and-rubber-goods-manufacturers",
    path: "/whoweserve/manufactureinsurance/plastic-and-rubber-goods-manufacturers",
    key: "plastic-and-rubber-goods-manufacturers",
    route: "/whoweserve/manufactureinsurance/plastic-and-rubber-goods-manufacturers",
    element: <PlasticRubberGoods />,
  },
  {
    name: "farm-equipment-manufacturing",
    path: "/whoweserve/manufactureinsurance/farm-equipment-manufacturing",
    key: "farm-equipment-manufacturing",
    route: "/whoweserve/manufactureinsurance/farm-equipment-manufacturing",
    element: <FarmEquipmentManufacturing />,
  },
  {
    name: "metalworking-insurance",
    path: "/whoweserve/manufactureinsurance/metalworking-insurance",
    key: "metalworking-insurance",
    route: "/whoweserve/manufactureinsurance/metalworking-insurance",
    element: <MetalWorkingInsurance />,
  },
  {
    name: "printers-insurance",
    path: "/whoweserve/manufactureinsurance/printers-insurance",
    key: "printers-insurance",
    route: "/whoweserve/manufactureinsurance/printers-insurance",
    element: <PrintersInsurance />,
  },

  {
    name: "retailer-and-distributor-insurance",
    path: "/whoweserve/distributorsandretailers",
    key: "retailer-and-distributor-insurance",
    route: "/whoweserve/distributorsandretailers",
    element: <DistributorsRetailers />,
  },
  //retailer-and-distributor sub pages
  {
    name: "retailer-and-distributor-insurance",
    path: "/whoweserve/distributorsandretailers/distributors-and-wholesaler-insurance",
    key: "retailer-and-distributor-insurance",
    route: "/whoweserve/distributorsandretailers/distributors-and-wholesaler-insurance",
    element: <Distributors />,
  },
  {
    name: "retailer-insurance",
    path: "/whoweserve/distributorsandretailers/retailer-insurance",
    key: "retailer-insurance",
    route: "/whoweserve/distributorsandretailers/retailer-insurance",
    element: <RetailerInsurance />,
  },
  {
    name: "truckinginsurance",
    path: "/whoweserve/truckinginsurance",
    key: "truckinginsurance",
    route: "/whoweserve/truckinginsurance",
    element: <TruckingInsurance />,
  },
  {
    name: "service-industry-insurance",
    path: "/whoweserve/serviceindustries",
    key: "service-industry-insurance",
    route: "/whoweserve/serviceindustries",
    element: <ServiceIndustries />,
  },
  // service industries
  {
    name: "AutomotiveRepair",
    path: "/whoweserve/serviceindustries/automotive-repair-shop-insurance",
    key: "AutomotiveRepair",
    route: "/whoweserve/serviceindustries/automotive-repair-shop-insurance",
    element: <AutomotiveRepair />,
  },
  {
    name: "communications-businesses-insurance",
    path: "/whoweserve/serviceindustries/communications-businesses-insurance",
    key: "communications-businesses-insurance",
    route: "/whoweserve/serviceindustries/communications-businesses-insurance",
    element: <Communications />,
  },
  {
    name: "FinancialServices",
    path: "/whoweserve/serviceindustries/financial-services-business-insurance",
    key: "FinancialServices",
    route: "/whoweserve/serviceindustries/financial-services-business-insurance",
    element: <FinancialServices />,
  },
  {
    name: "HospitalityBusinesses",
    path: "/whoweserve/serviceindustries/hospitality-businesses",
    key: "HospitalityBusinesses",
    route: "/whoweserve/serviceindustries/hospitality-businesses",
    element: <HospitalityBusinesses />,
  },
  {
    name: "golf-course-insurance",
    path: "/whoweserve/serviceindustries/golf-course-insurance",
    key: "golf-course-insurance",
    route: "/whoweserve/serviceindustries/golf-course-insurance",
    element: <GolfInsurance />,
  },
  {
    name: "educational-insurance",
    path: "/whoweserve/serviceindustries/educational-insurance",
    key: "educational-insurance",
    route: "/whoweserve/serviceindustries/educational-insurance",
    element: <EducationalInsurance />,
  },
  {
    name: "healthcare-businesses",
    path: "/whoweserve/serviceindustries/healthcare-businesses",
    key: "healthcare-businesses",
    route: "/whoweserve/serviceindustries/healthcare-businesses",
    element: <HealthcareBusinesses />,
  },
  {
    name: "commercial-real-estate",
    path: "/whoweserve/serviceindustries/commercial-real-estate",
    key: "commercial-real-estate",
    route: "/whoweserve/serviceindustries/commercial-real-estate",
    element: <RealEstate />,
  },
  

  ///what we offer
  {
    name: "What we offer",
    path: "/what-we-offer",
    key: "whatweoffer",
    route: "/whatweoffer",
    element: <WhatWeOfferMain />,
  },
  {
    name: "Insurance Product",
    path: "/what-we-offer/insurance-products",
    key: "insurance-products",
    route: "/what-we-offer/insurance-products",
    element: <InsuranceProduct />,
  },
  {
    name: "Works Compesation",
    path: "/what-we-offer/insurance-products/workers-compesation",
    key: "workers-compesation",
    route: "/what-we-offer/insurance-products/workers-compesation",
    element: <WorkerCompensation />,
  },
  //all subpages of Worker Compensation starts
  {
    name: "guaranteed-cost-insurance",
    path: "/what-we-offer/insurance-products/workers-compensation/guaranteed-cost-insurance",
    key: "guaranteed-cost-insurance",
    route: "/what-we-offer/insurance-products/workers-compensation/guaranteed-cost-insurance",
    element: <GuaranteedCostInsurance />,
  },
  {
    name: "RetrospectiveInsurance",
    path: "/what-we-offer/insurance-products/workers-compensation/retrospective-rating-insurance",
    key: "RetrospectiveInsurance",
    route: "/what-we-offer/insurance-products/workers-compensation/retrospective-rating-insurance",
    element: <RetrospectiveInsurance />,
  },
  {
    name: "small-deductible-plans",
    path: "/what-we-offer/insurance-products/workers-compensation/small-deductible-plans",
    key: "small-deductible-plans",
    route: "/what-we-offer/insurance-products/workers-compensation/small-deductible-plans",
    element: <SmallDeductiblePlans />,
  },
  {
    name: "large-deductible-plans",
    path: "/what-we-offer/insurance-products/workers-compensation/large-deductible-plans",
    key: "large-deductible-plans",
    route: "/what-we-offer/insurance-products/workers-compensation/large-deductible-plans",
    element: <LargeDeductiblePlans />,
  },
  {
    name: "self-insured-plans",
    path: "/what-we-offer/insurance-products/workers-compensation/self-insured-plans",
    key: "self-insured-plans",
    route: "/what-we-offer/insurance-products/workers-compensation/self-insured-plans",
    element: <SelfInsuredPlans />,
  },
  //all subpages of Worker Compensation ends

  {
    name: "General Liability",
    path: "what-we-offer/insurance-products/general-liability-insurance",
    key: "general-liability-insurance",
    route: "/what-we-offer/insurance-products/general-liability-insurance",
    element: <GeneralLiability />,
  },
    //all subpages of General Liability starts
  {
    name: "commercial-umbrella-insurance",
    path: "/what-we-offer/insurance-products/general-liability-insurance/commercial-umbrella-insurance",
    key: "commercial-umbrella-insurance",
    route: "/what-we-offer/insurance-products/general-liability-insurance/commercial-umbrella-insurance",
    element: <CommercialUmbrellaInsurance />,
  },
  {
    name: "EmploymentPracticesInsurance",
    path: "/what-we-offer/insurance-products/shared-insurance-products/employment-practices-liability-insurance",
    key: "EmploymentPracticesInsurance",
    route: "/what-we-offer/insurance-products/shared-insurance-products/employment-practices-liability-insurance",
    element: <EmploymentPracticesInsurance />,
  },
  {
    name: "errors-and-omissions-insurance",
    path: "/what-we-offer/insurance-products/general-liability-insurance/errors-and-omissions-insurance",
    key: "errors-and-omissions-insurance",
    route: "/what-we-offer/insurance-products/general-liability-insurance/errors-and-omissions-insurance",
    element: <ErrorsOmissionsInsurance />,
  },
  //all subpages of General Liability ends
  {
    name: "Commercial Properties",
    path: "what-we-offer/insurance-products/commercial-property-insurance",
    key: "commercial-property-insurancee",
    route: "/what-we-offer/insurance-products/commercial-property-insurance",
    element: <CommercialProperties />,
  },
  //all subpages of Commercial Properties starts
  {
    name: "building-insurance",
    path: "/what-we-offer/insurance-products/commercial-property-insurance/building-insurance",
    key: "building-insurance",
    route: "/what-we-offer/insurance-products/commercial-property-insurance/building-insurance",
    element: <BuildingInsurance />,
  },
  {
    name: "business-income-insurance",
    path: "/what-we-offer/insurance-products/shared-insurance-products/business-income-insurance",
    key: "business-income-insurance",
    route: "/what-we-offer/insurance-products/shared-insurance-products/business-income-insurance",
    element: <BusinessIncomeInsurance />,
  },
  {
    name: "business-personal-property-insurance",
    path: "/what-we-offer/insurance-products/shared-insurance-products/business-personal-property-insurance",
    key: "business-personal-property-insurance",
    route: "/what-we-offer/insurance-products/shared-insurance-products/business-personal-property-insurance",
    element: <BusinessPersonalInsurance />,
  },
  {
    name: "Crime Insurance",
    path: "/what-we-offer/insurance-products/commercial-property-insurance/crime-insurance",
    key: "Crime Insurance",
    route: "/what-we-offer/insurance-products/commercial-property-insurance/crime-insurance",
    element: <CrimeInsurance />,
  },
  {
    name: "equipment-breakdown-coverage",
    path: "/what-we-offer/insurance-products/shared-insurance-products/equipment-breakdown-coverage",
    key: "equipment-breakdown-coverage",
    route: "/what-we-offer/insurance-products/shared-insurance-products/equipment-breakdown-coverage",
    element: <EquipmentBreakdown />,
  },
  {
    name: "inland-marine-insurance",
    path: "/what-we-offer/insurance-products/commercial-property-insurance/inland-marine-insurance",
    key: "inland-marine-insurance",
    route: "/what-we-offer/insurance-products/commercial-property-insurance/inland-marine-insurance",
    element: <InlandMarineInsurance />,
  },

  //all subpages of Commercial Properties starts
  {
    name: "Bussiness owner Insurance",
    path: "what-we-offer/insurance-products/business-owner-insurance",
    key: "Bussiness owner Insurance",
    route: "/what-we-offer/insurance-products/business-owner-insurance",
    element: <BussinessOwnerInsurance />,
  },
  //all subpages of bussiness owner insurance starts
  {
    name: "Business liability insurance",
    path: "/what-we-offer/insurance-products/business-owner-insurance/business-liability-insurance",
    key: "Business liability insurance",
    route: "/what-we-offer/insurance-products/business-owner-insurance/business-liability-insurance",
    element: <BusinessLiabilityInsurance />,
  },
  {
    name: "property-coverage",
    path: "/what-we-offer/insurance-products/business-owner-insurance/property-coverage",
    key: "property-coverage",
    route: "/what-we-offer/insurance-products/business-owner-insurance/property-coverage",
    element: <PropertyCoverage />,
  },
  //all subpages of bussiness owner insurance ends

  {
    name: "Bussiness Auto Insurance",
    path: "what-we-offer/insurance-products/business-auto-insurance",
    key: "business-auto-insurance",
    route: "/what-we-offer/insurance-products/business-auto-insurance",
    element: <BussinessAutoInsurance />,
  },
  //all subpages of bussiness auto insurance starts
  {
    name: "commercial-auto-insurance",
    path: "/what-we-offer/insurance-products/business-auto-insurance/commercial-auto-insurance",
    key: "commercial-auto-insurance",
    route: "/what-we-offer/insurance-products/business-auto-insurance/commercial-auto-insurance",
    element: <CommercialAutoInsurance />,
  },
  {
    name: "motor-carrier-insurance",
    path: "/what-we-offer/insurance-products/business-auto-insurance/motor-carrier-insurance",
    key: "motor-carrier-insurance",
    route: "/what-we-offer/insurance-products/business-auto-insurance/motor-carrier-insurance",
    element: <MotorCarrierInsurance />,
  },
  {
    name: "dealership-auto-coverage",
    path: "/what-we-offer/insurance-products/business-auto-insurance/dealership-auto-coverage",
    key: "dealership-auto-coverage",
    route: "/what-we-offer/insurance-products/business-auto-insurance/dealership-auto-coverage",
    element: <DealershipAutoCoverage />,
  },
  //all subpages of bussiness auto insurance ends

  {
    name: "401k-plans-and-life-insurance",
    path: "what-we-offer/insurance-products/401k-plans-and-life-insurance",
    key: "401k-plans-and-life-insurance",
    route: "/what-we-offer/insurance-products/401k-plans-and-life-insurance",
    element: <Plans401kAndInsurance />,
  },

  // all subpages of plan401 and insurance starts
  {
    name: "Plans 401k",
    path: "what-we-offer/insurance-products/401k-plans-and-life-insurance/401k-plans",
    key: "401k-plans",
    route: "/what-we-offer/insurance-products/401k-plans-and-life-insurance/401k-plans",
    element: <Plan401k/>,
  },
  {
    name: "busssinesslifeinsurance",
    path: "what-we-offer/insurance-products/401k-plans-and-life-insurance/business-life-insurance",
    key: "busssinesslifeinsurance",
    route: "/what-we-offer/insurance-products/401k-plans-and-life-insurance/business-life-insurance",
    element: <BussinessLifeInsurance/>,
  },
  {
    name: "IndividualLifeInsurance",
    path: "what-we-offer/insurance-products/401k-plans-and-life-insurance/individual-life-insurance",
    key: "IndividualLifeInsurance",
    route: "what-we-offer/insurance-products/401k-plans-and-life-insurance/individual-life-insurance",
    element: <IndividualLifeInsurance/>,
  },
  // all subpages of plan401 and insurance ends

  // Why Choose Sentry
  {
    name: "whychoosesentry",
    path: "/whychoosesentry",
    key: "whychoosesentry",
    route: "/whychoosesentry",
    element: <WhyChooseSentry />,
  },
  //Claims
  {
    name: "claims",
    path: "/claims",
    key: "claims",
    route: "/claims",
    element: <Claims />,
  },
  //Contact us
  {
    name: "Contactus",
    path: "/contact-us",
    key: "contactus",
    route: "/contactus",
    element: <Contactus />,
  },
  //Footer notice
  {
    name: "Customer notifications",
    path: "/footer/customer-notifications",
    key: "customernotifications",
    route: "/customernotifications",
    element: <CustomerNotifications />,
  },
  {
    name: "Legal Disclaimer",
    path: "/footer/legal-disclaimer",
    key: "legaldisclaimer",
    route: "/legal-disclaimer",
    element: <LegalDisclaimer />,
  },
  {
    name: "Terms and Conditions",
    path: "/terms-and-conditions",
    key: "terms-and-conditions",
    route: "/terms-and-conditions",
    element: <TermsConditions/>,
  },
  {
    name: "Web Accessibility",
    path: "/footer/web-accessibility",
    key: "web-accessibility",
    route: "footer/web-accessibility",
    element: <WebAccessibility/>,
  },
  //customer
  {
    name: "Customer",
    path: "/customers",
    key: "customer",
    route: "/customers",
    element: <Customer/>,
  },
  {
    name: "Agent",
    path: "/for-agents-and-brokers",
    key: "agent",
    route: "/for-agents-and-brokers",
    element: <Agent/>,
  },

  //privacy
  {
    name: "Privacy",
    path: "/privacy",
    key: "privacy",
    route: "/privacy",
    element: <Privacy/>,
  },
  //sidemap
  {
    name: "Sitemap",
    path: "/sitemap",
    key: "sitemap",
    route: "/sitemap",
    element: <Sitemap/>,
  },
  //claim status
 
];

export default RouteArr;
